import { render } from "./ItensAcessorio.vue?vue&type=template&id=69b7261b&scoped=true"
import script from "./ItensAcessorio.vue?vue&type=script&lang=js"
export * from "./ItensAcessorio.vue?vue&type=script&lang=js"

import "./ItensAcessorio.vue?vue&type=style&index=0&id=69b7261b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b7261b"]])

export default __exports__